<template>
  <el-radio-group
    v-model="selectedProfileType"
    class="justify-content-center align-items-center px-6 py-3"
    size="large"
  >
    <el-radio-button
      v-for="profileType in data"
      :key="profileType.dna_profile_id"
      :label="profileType.dna_profile_id"
      :value="profileType.dna_profile_id"
      :disabled="!profileType.is_active"
      :class="{ disabled: !profileType.is_active }"
      class="profile-type-pill ms-3 text-capitalize"
      @click="selectProfileType(profileType)"
    >
      {{ profileType.dna_profile_name }}
    </el-radio-button>
  </el-radio-group>
</template>

<script>
export default {
  name: "ProfileTypes",
  props: {
    data: {
      type: Array,
      required: true,
    },
    selectedProfileTypeId: {
      type: String,
      default: -1,
    },
  },
  emits: ["selected-profile-type"],
  data() {
    return {
      selectedProfileType: -1,
    };
  },
  watch: {
    selectedProfileTypeId(newValue) {
      this.selectedProfileType = newValue;
    },
  },
  mounted() {
    if (this.selectedProfileTypeId == -1) {
      this.selectedProfileType =
        this.data.length > 0 ? this.data[0].dna_profile_id : -1;
    } else {
      this.selectedProfileType = this.selectedProfileTypeId;
    }
  },
  methods: {
    selectProfileType(profileType) {
      if (profileType.is_active)
        this.$emit("selected-profile-type", profileType);
    },
  },
};
</script>

<style lang="scss" scoped>
:export {
  primary: $primary;
}

.profile-type-pill {
  border-radius: 24px;
  border: 2px solid white;

  &.is-active {
    border-color: $primary;
  }
  &:hover {
    border-color: $primary;
  }
}
.disabled {
  border: 2px solid $dark;
}
</style>
